module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_state !== 1\"> <a class=text-center style=opacity:.85;text-decoration:underline ng-click=grid.appScope.specialSituationVM.showDetailsModal(row.entity)> Ver detalles </a> </div> <div ng-if=\"row.entity.id_state === 1\"> <md-button has-permission=situaciones-especiales-edit class=\"btn btn-success text-xs grid-btn\" ng-click=grid.appScope.specialSituationVM.showAddSituationModal(row.entity)> Agregar situación </md-button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workPlanParametrization/special/cellActionSpecialSituations.html
// module id = 227
// module chunks = 0